import { useSelector } from 'react-redux';
import { ICreateConversionDTO, useCreateConversionMutation } from '../../services/marketing.service';
import { RootState } from '../../store';

export interface IEventConversionPayload {
  conversionIdentifier: string;
}

interface IUseCreateConversion {
  createConvertion: (data: IEventConversionPayload) => void;
}

export function useCreateConversion(): IUseCreateConversion {
  const {
    oyana: { me }
  } = useSelector((state: RootState) => state);

  const [postCreateConversion] = useCreateConversionMutation();
  const createConvertion = (data: IEventConversionPayload): void => {
    const payload: ICreateConversionDTO = {
      conversionIdentifier: data.conversionIdentifier,
      email: me.email,
      name: me.fullName,
      tags: ['minha-conta']
    };
    try {
      postCreateConversion(payload);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    createConvertion
  };
}
